import React from "react";
import Navbar from "../../../Navbar/Navbar";
import ScroollTableQarzeWakel from "./ScroollTableQarzeWakel";
import FooterOfQarzWakel from "./FooterOfQarzWakel";
import FillDetailQarzeWakel from "./FillDetailQarzeWakel";
const AllKogaRaport = () => {
  return (
    <div>
      <Navbar />
      <div style={{ marginTop: "50px" }}>
        <div className="row" style={{ backgroundColor: "#2C3539" }}>
          <div className="col-12 ">
            <FillDetailQarzeWakel />
          </div>
        </div>
        <div className="row">
          <div className="col-12 ">
            <ScroollTableQarzeWakel />
          </div>
        </div>
        <div className="row " style={{ backgroundColor: "#2C3539" }}>
          <div className="col-lg-12 col-12">
            <FooterOfQarzWakel />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllKogaRaport;
